import { useQuery } from "react-query";

import { getProduct } from "@/api/Maintainers/Products/products-query";

const key = "product-detail";

export function useProductDetail(params) {
	return useQuery([key, params], () => params && getProduct(params), {
		enabled: params.product_id !== "",
	});
}
